import { render, staticRenderFns } from "./SquarePlasticBadge.vue?vue&type=template&id=7fcb3506&scoped=true&"
import script from "./SquarePlasticBadge.vue?vue&type=script&lang=js&"
export * from "./SquarePlasticBadge.vue?vue&type=script&lang=js&"
import style0 from "./SquarePlasticBadge.vue?vue&type=style&index=0&id=7fcb3506&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fcb3506",
  null
  
)

component.options.__file = "SquarePlasticBadge.vue"
export default component.exports